"use client";

import React from "react";
import { Mail, Phone, MapPin, Building2, MessageSquare } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="contact" ref={ref} className="relative bg-primary text-primary-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--accent)_0%,_transparent_40%)] opacity-20 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-primary to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid gap-12 items-start transition-all duration-1000 opacity-100 translate-y-0 !w-[1600px] !h-[550px] lg:grid-cols-2">
          
          {}
          <div className="flex flex-col gap-10 lg:pr-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-foreground/10 text-primary-foreground text-sm font-medium border border-primary-foreground/10 backdrop-blur-sm">
                <span className="relative flex size-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full size-2 bg-green-500"></span>
                </span>
                Open for New Projects
              </div>
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white">
                Request Platform Access
              </h2>
              <p className="text-lg text-primary-foreground/80 max-w-md leading-relaxed">
                Ready to accelerate your business? Get in touch with our team to discover how our platform can transform your operations.
              </p>
            </div>

            <div className="space-y-8">
              {}
              <div className="grid gap-6">
                <div className="flex items-start gap-4 group">
                  <div className="size-12 rounded-xl bg-primary-foreground/10 flex items-center justify-center shrink-0 group-hover:bg-primary-foreground/20 transition-colors border border-primary-foreground/10">
                    <Mail className="size-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white text-lg">Email Us</h3>
                    <p className="text-primary-foreground/70 mb-1">For general inquiries and support</p>
                    <Link to="mailto:contact@profissapro.com" className="text-white hover:text-accent-foreground font-medium transition-colors">
                      Profissa Pro™
                    </Link>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="size-12 rounded-xl bg-primary-foreground/10 flex items-center justify-center shrink-0 group-hover:bg-primary-foreground/20 transition-colors border border-primary-foreground/10">
                    <Phone className="size-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white text-lg">Call Us</h3>
                    <p className="text-primary-foreground/70 mb-1">Mon‑Fri, 9 am – 6 pm (EST)</p>
                    <Link to="tel:+17865099691" className="text-white hover:text-accent-foreground font-medium transition-colors">
                      Phone – Profissa Pro Support +1 (786) 509-9691 Miami, Florida – USA
                    </Link>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="size-12 rounded-xl bg-primary-foreground/10 flex items-center justify-center shrink-0 group-hover:bg-primary-foreground/20 transition-colors border border-primary-foreground/10">
                    <MapPin className="size-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white text-lg">Visit Our Headquarters</h3>
                    <p className="text-primary-foreground/70 mb-1">Visit us at our headquarters</p>
                    <address className="not-italic text-white/90">
                      Miami, Florida – USA
                    </address>
                  </div>
                </div>
              </div>

              {}
              
            </div>
          </div>

          {}
          <div className="lg:pl-4 flex flex-col justify-center">
            <div className="flex flex-col gap-4">
              <Button size="lg" className="w-full bg-white text-primary hover:bg-white/90 font-bold py-7 text-lg rounded-xl shadow-xl transition-all hover:scale-[1.02]">
                Start Exploring the Platform
              </Button>
              <Button variant="outline" size="lg" className="w-full border-white/30 text-white hover:bg-white/10 py-7 text-lg rounded-xl transition-all hover:scale-[1.02]">
                Watch the Demo
              </Button>
              <Button variant="outline" size="lg" className="w-full border-white/30 text-white hover:bg-white/10 py-7 text-lg rounded-xl transition-all hover:scale-[1.02]">
                Explore Profissa Pro™
              </Button>
            </div>
            
            <div className="mt-8 flex items-center justify-center gap-6 text-primary-foreground/40 text-sm">
              <div className="flex items-center gap-2">
                <MessageSquare className="size-4" />
                <span>24/7 Customer Support</span>
              </div>
              <div className="w-1 h-1 rounded-full bg-primary-foreground/20" />
              <div>Secure SSL Encryption</div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}